import { FC } from 'react'
import { FilterSection } from '@/network/graphql.g'
import MobileFilterGridItem, {
  MobileFilterItemType
} from './mobileFilterGridItem'

type Props = {
  materials: FilterSection[]
  initialSelections: string[]
  updatePendingFilter: (ids: string[]) => void
}

const FilterMaterialsSlidePage: FC<Props> = ({
  materials,
  initialSelections,
  updatePendingFilter
}) => {
  const items: MobileFilterItemType[] = materials.flatMap((s) =>
    s.items.map((i) => ({
      id: i.id,
      title: i.title,
      count: i.count
    }))
  )

  return (
    <MobileFilterGridItem
      items={items}
      selectedIds={initialSelections}
      onSelectionChange={updatePendingFilter}
    />
  )
}
export default FilterMaterialsSlidePage
